import "./Home.module.css";
import SiteHeader from "@/reusable_sections/Header";
import AGentleGoodbye from "./sections/AGentleGoodbye";
import TheScienceOfMyLight from "./sections/TheScienceOfMyLight";
import DoneForYouAllOfIt from "./sections/DoneForYouAllOfIt";
import AreasOfFocus from "./sections/AreasOfFocus";
import Trustbar from "./sections/Trustbar";
import FooterInformation from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <SiteHeader />
      <AGentleGoodbye />
      <TheScienceOfMyLight />
      <DoneForYouAllOfIt />
      <AreasOfFocus />
      <Trustbar />
      <FooterInformation />
    </div>;
}